import { jsonPostRequest } from '@/plugin/axios/commonApi'

export function loadStudentInfo () {
  return jsonPostRequest('/student/apply/findStudentInfo')
}

export function find (params) {
  return jsonPostRequest('/student/apply/find', params)
}

export function submitAndCreateApply (params) {
  return jsonPostRequest('/student/apply/submitStudentInfo', params)
}

export function confirmPack (params) {
  return jsonPostRequest('/student/apply/confirmPack', params)
}

export function confirmReceiveInfo (params) {
  return jsonPostRequest('/student/apply/confirmReceiveInfo', params)
}

export function generateBillDetail (params) {
  return jsonPostRequest('/student/apply/generateBillDetail', params)
}

export function confirmPayTypeAndSubmit (params) {
  return jsonPostRequest('/student/apply/confirmPayTypeAndSubmit', params)
}

export function initOnlinePaySubmit (params) {
  return jsonPostRequest('/student/apply/initOnlinePay/submit', params)
}

export function initOnlinePayApplyList (params) {
  return jsonPostRequest('/student/apply/initOnlinePay/applyList', params)
}

export function list (params) {
  return jsonPostRequest('/student/apply/list', params)
}

export function listBankTransferVoucher (params) {
  return jsonPostRequest('/student/apply/listBankTransferVoucher', params)
}

export function confirmBankTransfer (params) {
  return jsonPostRequest('/student/apply/confirmBankTransfer', params)
}

export function cancel (params) {
  return jsonPostRequest('/student/apply/cancel', params)
}

export function quickQuery (params) {
  return jsonPostRequest('/student/apply/quickQuery', params)
}

export function quickView (params) {
  return jsonPostRequest('/student/apply/quickView', params)
}

export function confirmUseCashPay (params) {
  return jsonPostRequest('/student/apply/confirmUseCashPay', params)
}

export function lastApply () {
  return jsonPostRequest('/student/apply/lastApply')
}
